import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {CommissionSeance} from '../../../interface/api/CommissionSeance';
import {CommissionType} from '../../../interface/api/CommissionType';
import { KeyValue, DatePipe, KeyValuePipe } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {CommissionSeanceInterface} from '../../../class/api/CommissionSeance';
import { MatDivider } from '@angular/material/divider';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelectionList, MatListSubheaderCssMatStyler, MatListOption, MatListItemAvatar, MatListItemTitle, MatListItemLine } from '@angular/material/list';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-selection-reunions',
    templateUrl: './modal-selection-reunions.component.html',
    styleUrls: ['./modal-selection-reunions.component.scss'],
    imports: [MatDialogTitle, MatDivider, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatSelectionList, MatListSubheaderCssMatStyler, MatListOption, MatListItemAvatar, MatListItemTitle, MatListItemLine, MatDialogActions, MatButton, MatDialogClose, DatePipe, KeyValuePipe]
})
export class ModalSelectionReunionsComponent implements OnInit, OnDestroy {
    data = inject(MAT_DIALOG_DATA);
    private translateService = inject(TranslateService);


    title = '';
    cancel = 'Annuler';
    confirm = 'Ajouter';
    private subscriptions: Subscription[] = [];

    public multiple = false;
    public commissionSeances: {
        [commissionTypeCode: string]: {
            commissionType: CommissionType;
            commissionSeances: CommissionSeanceInterface[];
        };
    } = {};

    public form: FormGroup;

    constructor() {
        const data = this.data;


        this.form = new FormGroup(
            {
                commissionSeancesForm: new FormControl<CommissionSeance[]>([])
            }
        );

        if (!data) {
            return;
        }

        this.multiple = data.multiple ?? false;

        if(data.title){
            this.title = data.title;
        }else{
            this.title = this.multiple ? 'Sélectionnez une ou plusieurs étapes' : 'Sélectionnez une étape';
        }

        if(data.confirm){
            this.confirm = data.confirm;
        }

        if (data.commissionSeances) {
            this.commissionSeances = data.commissionSeances.reduce(
                (obj, item: CommissionSeance) => {
                    const commission = item.commission ?? null;
                    if (!commission) {
                        return obj;
                    }

                    const commissionType = commission.commissionType;
                    if (!commissionType) {
                        return obj;
                    }

                    if (!obj[commissionType.code]) {
                        obj[commissionType.code] = {
                            commissionType,
                            commissionSeances: [item]
                        };
                    } else {
                        obj[commissionType.code].commissionSeances.push(item);
                    }

                    return obj;
                },
                this.commissionSeances
            );
        }
    }

    sortByCommissionType = (akv: KeyValue<string, any>, bkv: KeyValue<string, any>): number => {
        const a = akv.value?.commissionType?.id ?? 99;
        const b = bkv.value?.commissionType?.id ?? 99;

        return a > b ? 1 : (b > a ? -1 : 0);
    };


    ngOnInit() {
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(item => item.unsubscribe());
    }
}
